import React from 'react'

const PriceDevelopment = ({ colorOption = 'blue' }) => {
  return (
    <div className="relative max-w-sm mx-auto">
      <svg
        className={`w-full h-full stroke-current ${
          colorOption === 'charcoal' ? 'text-charcoal-500' : 'text-blue-500'
        }`}
        viewBox="0 0 297 68"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 66.5l26.594-23.625 29.884-4.348L79.574 18 118.9 41l25.975-18.25L188.56 43.5 216.3 30.8 235 43.5 295.293 2"
          strokeWidth="4"
          fill="none"
          fillRule="evenodd"
        />
      </svg>
      <div
        className={`absolute flex items-center justify-center w-10 h-10 text-sm font-bold text-white rounded-full right-3.5 top-1.5 ${
          colorOption === 'charcoal' ? 'bg-charcoal-500' : 'bg-blue-500'
        }`}
      >
        +2%
      </div>
    </div>
  )
}

export default PriceDevelopment
